import API from "api/client";
import { ApiNode } from "types";
import { envConfig } from "config";

const { categoriesAPI } = envConfig;

/**
 * Get category hierarchy.
 */
const getHierarchy = async () => {
  return API.get<ApiNode[]>(`${categoriesAPI}hierarchy`).then((res) => res.data);
};

export default {
  hierarchy: getHierarchy,
};
